import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";

import { Header } from "components/Header";

export const StyledUserData = styled.div<Props>`
  display: flex;
  column-gap: 0.5rem;
  align-items: center;
  justify-content: flex-end;

  margin-right: 1rem;

  color: ${(props: Props) => props.theme.palette.neutral._400};
  text-transform: capitalize;
`;

export const StyledAdminHeader = styled(Header)`
  grid-area: header;
  width: 100%;
`;
